import React from "react";
//#region types
import { DialogProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#region components
import DialogLayout from "components/common/dialogs/_layout";
import FileViwerContextProvider from "../fileViewer/context/contextProvider";
//#endregion
import cssExports from "theme/styles/main.module.scss";

// Wrapper component that accepts and ignores dialog-specific props
const MessageContent = React.forwardRef<HTMLDivElement, { children: React.ReactNode; onFormValidationChange?: any }>(
  (props, ref) => {
    const { children, onFormValidationChange, ...rest } = props;
    return (
      <div ref={ref} {...rest}>
        {children}
      </div>
    );
  }
);

const MessageDialog: React.FC<DialogProps> = (props) => {
  const ContextProvider = props.contextProvider;
  const dialogLayout = (
    <DialogLayout {...props} class={cssExports.messageDialog} hideDivider={true}>
      <MessageContent>{props.children as React.ReactNode}</MessageContent>
    </DialogLayout>
  );

  return (
    <FileViwerContextProvider>
      {ContextProvider ? (
        <ContextProvider {...props.contextProviderProps}>{dialogLayout}</ContextProvider>
      ) : (
        dialogLayout
      )}
    </FileViwerContextProvider>
  );
};

export default MessageDialog;
